



























import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default Vue.extend({
  name: 'HMDateRangePicker',
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object as () => DatePicker,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: null,
      } as DatePicker,
    };
  },
  mounted() {
    this.dateRange = this.value;
  },
  watch: {
    dateRange: {
      handler(value: DatePicker) {
        this.$emit('input', value);
      },
    },
  },
  filters: {
    date: function (value: Date): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
});
